import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ReservationPreChekin } from '../../reservation/models/reservation-response';
import { BranchesInternationalRepository } from '../repositories/branches-international.repository';
import { BranchIntParams } from '../models/branch-international.model';

export class SaveLocationIntUseCase implements UseCase<any, any> {
    constructor(private readonly repository: BranchesInternationalRepository) {}

    execute(params: BranchIntParams): Observable<any> {
        return this.repository.saveLocationInt(params);
    }
}
